'use client';

import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { useProfileDataQuery } from '../../hooks/use-profile-data-query';
import { getPlayedGames } from '../../utils/get-played-games';
import { MyLibraryCard } from '../my-library-card';
import { MyLibraryEmptyState } from '../my-library-empty-state';
import * as Styled from './my-library.styled';
export const MyLibrary = React.memo(function MyLibrary() {
  const profileModel = useEdgeConfigWidget(WidgetId.Profile);
  const {
    data,
    isLoading
  } = useProfileDataQuery();
  if (!data || !data.userGames || isLoading || !profileModel.repeaters.games) {
    return null;
  }
  const playedGames = getPlayedGames(profileModel.repeaters.games, data.userGames);
  if (!playedGames || playedGames.length === 0) {
    return <MyLibraryEmptyState />;
  }
  return <Styled.Grid>
      {playedGames.map(playedGame => <MyLibraryCard key={playedGame.options.compositeId} image={playedGame.images.image} title={playedGame.strings.title} buttonText={playedGame.strings.buttonText} buttonUrl={playedGame.links.url} gameId={playedGame.options.gameId} />)}
    </Styled.Grid>;
});